<template>
  <v-row :class="{ animate: animate }" justify="center">
    <vertical-slots-machine
      v-for="(result, index) in digits"
      class="col col-auto"
      :key="index"
      :stop-number="parseInt(result, 10)"
      :spin="spinning"
    >
    </vertical-slots-machine>
  </v-row>
</template>

<script>
import VerticalSlotsMachine from "./VerticalSlotsMachine.vue";
import { Howl } from "howler";
import SpinSound from "../../../../../assets/static/sounds/Casino slot machine - musical -wheels spinning- arpeggio - seamless looping 5.mp3";

export default {
  name: "SlotMachine",
  props: {
    digits: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      spinning: false,
      spinSound: SpinSound,
      sound: new Howl({
        src: SpinSound,
        volume: 0.4,
        loop: true,
        autoPlay: false
      }),
      animate: false
    };
  },
  components: {
    VerticalSlotsMachine
  },
  methods: {
    start() {
      this.spinning = true;
      this.sound.play();
    },
    stop() {
      return new Promise(resolve => {
        this.spinning = false;
        setTimeout(() => {
          this.sound.stop();
          setTimeout(() => {
            this.animate = true;
          }, 1000);
          resolve();
        }, 3000);
      });
    }
  }
};
</script>

<style scoped>
@keyframes zoominoutsinglefeatured {
  0% {
    transform: scale(1, 1);
  }
  50% {
    transform: scale(1.2, 1.2);
  }
  100% {
    transform: scale(1, 1);
  }
}

.animate {
  animation: zoominoutsinglefeatured 1s infinite;
}
</style>
